export default __webpack_public_path__ + "static/media/tsm&o-white.150602dd.png";